import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * 404 page
 */
@Component( {
    selector: 'riege-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
} )
export class NotFoundComponent {
    #router = inject( Router );

    constructor() { }

    /** helper function to navigate back to homepage */
    goHome() {
        this.#router.navigate( ['/'] );
    }
}
